import { BiButtonGroup, BiButton, BiMessageBox } from 'bi-web-components-react';
import { useTranslation } from 'react-i18next';

export type ChatFeedbackProps = {
    onNavigateBack: () => void;
    type: 'error' | 'confirmation';
};

export default function ChatFeedback({ onNavigateBack, type }: ChatFeedbackProps) {
    const { t } = useTranslation('chat');
    return (
        <div className={'ChatFeedback-container'}>
            <BiMessageBox
                variant={type === 'error' ? 'error' : 'success'}
                message={type === 'error' ? t('error') : t('thankYou')}
            />
            <BiButtonGroup alignment='center' top='large'>
                <BiButton tabIndex={0} onClick={onNavigateBack} variant='outlined'>
                    {t('back')}
                </BiButton>
            </BiButtonGroup>
        </div>
    );
}
